import { Layout } from "antd";
import UISidebar from "../common/sidebar";
import UIHeader from "../common/header";
import { Outlet, useLocation } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
import { selectCurrentAppState } from "../../redux/features/app/appSlice";
const { Content } = Layout;
const UILayout = () => {
  const [collapsed, setCollapsed] = useState(false);

  const {showSideBar} = useSelector(selectCurrentAppState)
  const location = useLocation();

  // Check if the current route is '/activitylogs'
  const shouldHideSidebar = location.pathname === '/activitylogs';
  return (
    <Layout
      style={{
        minHeight: "100vh",
      }}
    >
      <UIHeader setCollapsed={setCollapsed} collapsed={collapsed} />
      <Layout className="site-layout" style={{ marginTop: "60px" }}>
        {!shouldHideSidebar ? 
        <UISidebar setCollapsed={setCollapsed} collapsed={collapsed} /> : null}

        <Content
          style={{
            margin: "0 0px",
            marginLeft: !shouldHideSidebar ? collapsed ? 80: 250: 0
          }}
        >

          <div
            className="site-layout-background" 
            style={{
              padding: 24,
              // height:'100%'
            }}
          >


            <Outlet />

          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default UILayout;
